<template>
  <div class="card">
    <div class="card-body">
      <div class="text-center">
        <div class="row justify-content-center">
          <div class="col-sm-6 col-8">
            <div>
              <img src="@/assets/images/templates/warranty.svg" alt class="img-fluid" style="width: 60% !important;"/>
            </div>
          </div>
        </div>

        <div class="row justify-content-center mb-3">
          <div class="col-lg-10 justify-content-center" style="text-align: -webkit-center;">
            <h4 class="mt-4 fw-semibold">{{ $t('pages.template_builder.warranty_request.title') }}</h4>
            <p class="text-muted mt-3">
              {{ $t('pages.template_builder.warranty_request.info') }}
            </p>
            <div class="mt-4 w-50">
              <b-form-group :label="$t('pages.template_builder.warranty_request.period')" label-for="warranty">
                <quantity-input v-model="warranty" :min="1"/>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuantityInput from "../../../../components/widgets/QuantityInput";

export default {
  name: "WarrantyRequest",
  components: {QuantityInput},
  data() {
    return {
      warranty: 1
    }
  },
  watch: {
    warranty(newVal) {
      this.$emit('warranty', newVal)
    }
  }
}
</script>

<style scoped>

</style>